// extracted by mini-css-extract-plugin
export default {"container":"loading_container__bPVzT","spinner":"loading_spinner__-+7IQ","compact":"loading_compact__msyCr"};